let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6af4M")).then(() => parcelRequire('bniYD'));